export default __webpack_public_path__ + "static/media/supply-green-icon.f42a17c2.svg";